export const SET_STATES = 'SET_STATES'
export const REFRESH_STATES = 'REFRESH_STATES'
export const SET_ADVANCED = 'SET_ADVANCED'
